import {
	mapMutations,
	mapGetters,
	mapState,
	mapActions,
} from 'vuex';
import formulateUserProfile from '~/mixins/formulateUserProfile';

const STEPS = {
	LOGIN: 'login',
	LOGIN_ID: 'loginId',
	INFO: 'info',
	DOCUMENTS: 'documents',
	PAYMENT: 'payment',
	FINISH: 'finish',
	COMPANY: 'company',
	RESET: 'reset',
};

const STEPS_COMPONENT = {
	login: 'AuthStep',
	loginId: 'AuthStepWithId',
	info: 'FirstStep',
	documents: 'SecondStep',
	payment: 'ThirdStep',
	finish: 'SuccessStep',
	company: 'CompanyStep',
};

const FINISH_STEP = 'finish';
export default {
	mixins: [formulateUserProfile],
	data() {
		return {
			STEPS,
			STEPS_COMPONENT,
			FINISH_STEP,
			autoFields: [],
			promocode: '',
			promocodeMessage: null,
			promocodeButtonText: 'Применить',
			isLoadingPromocode: false,
			isActivatePromocode: false,
			priceWithPromocode: null,
			priceWithPromocodeWithoutDiscount: null,
		};
	},
	watch: {
		promocode() {
			this.promocodeMessage = null;
		},
		currentPromocode(promocode) {
			this.promocode = promocode.value;
			this.isActivatePromocode = promocode.isActive;
		},
	},
	computed: {
		...mapState('scenarios/paymentForm', [
			'orderHash',
			'currentPromocode',
		]),
		...mapGetters('scenarios/paymentForm', [
			'baseForm',
		]),
	},
	methods: {
		...mapMutations('scenarios/paymentForm', [
			'setForm',
			'setFieldsDisabled',
			'setPrice',
			'setPromocode',
			'setProduct',
		]),
		...mapActions('scenarios/paymentForm', ['getPersonData']),

		syncForm(fields, form) {
			// Копируем только указанные поля
			const formFormatted = fields.reduce((acc, field) => {
				if (field in form) {
					acc[field] = form[field];
				}
				return acc;
			}, {});
			this.setForm(formFormatted);
		},
		async autocompleteLocalForm(localForm, fields) {
			const user = await this.getFormulateUser();
			const data = user || {};

			fields.forEach((field) => {
				if (field in data) {
					if (data[field]) {
						this.autoFields = [...this.autoFields, field];
						// eslint-disable-next-line no-param-reassign
						if (field.includes('phone')) {
							localForm[field] = !data[field].startsWith('+') ? `+${data[field]}` : data[field];
							return;
						}
						localForm[field] = data[field];
					}
				} else if (field in this.$auth.user || {}) {
					if (!this.$auth.user[field]) return;
					this.autoFields = [...this.autoFields, field];
					// eslint-disable-next-line no-param-reassign
					localForm[field] = this.$auth.user[field];
				}
			});

			if (this.autoFields.length) {
				this.setFieldsDisabled(true);
			}
		},
		areAllFieldsFilled(obj) {
			return Object.values(obj).every((value) => value !== null && value !== '' && value !== undefined);
		},
		async updateBaseFormData() {
			/* Обновляем данных формы чтобы при возврате назад с другого
			домена из кэша браузера были получены актуальные данные */
			this.$emit('updateOrder');
			await this.getPersonData(this.block?.scenario_id);
		},
		async resetPromocodeForm(promo, reference) {
			try {
				const data = { promo, reference };
				const response = await this.$api.removePromocodeScenario(data);

				this.setPrice({ value: null, key: 'withPromocode' });
				this.setPrice({ value: response.amount, key: 'initial' });
				this.setPromocode({ value: null, isActive: false });

				this.promocode = '';
				this.isActivatePromocode = false;
				this.priceWithPromocode = null;
				this.priceWithPromocodeWithoutDiscount = null;
				this.promocodeDiscountPrice = null;
			} catch (e) {
				console.log(e);
				this.promocodeMessage = 'Произошла ошибка';
			} finally {
				await this.updateBaseFormData();
			}
		},
		async applyPromocode(promo, reference, entityType) {
			try {
				const data = { promo, reference, entity_type: entityType };
				const response = await this.$api.applyPromocodeScenario(data);
				const { amount, reason, success } = response;

				this.setPrice({ value: amount, key: 'withPromocode' });
				this.setPromocode({ value: this.promocode, isActive: success });

				this.priceWithPromocode = Math.floor(amount);
				this.isActivatePromocode = success;
				this.promocodeMessage = reason || null;
			} catch (e) {
				console.log(e);
				const isTypeError = e.response.status === 403;
				this.promocodeButtonText = 'Применить';
				this.promocodeMessage = isTypeError
					? 'Неверный промокод'
					: 'Произошла какая-то ошибка';
				this.setPrice({ value: null, key: 'withPromocode' });
				this.isActivatePromocode = false;
				this.isLoadingPromocode = false;
			} finally {
				await this.updateBaseFormData();
			}
		},
		validateCyrillic(value, options = {}) {
			const {
				allowSpaces = true, // Разрешить пробелы
				allowHyphens = false, // Разрешить дефисы
				allowDigits = false, // Разрешить цифры
				additionalChars = '', // Дополнительные разрешенные символы
			} = options;

			// Формируем часть regex для разрешённых символов
			let allowedSymbols = '';
			if (allowSpaces) allowedSymbols += '\\s';
			if (allowHyphens) allowedSymbols += '\\-';
			if (allowDigits) allowedSymbols += '0-9';
			if (additionalChars) {
				allowedSymbols += additionalChars.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
			}

			// Регулярное выражение:
			// Либо кириллица + разрешённые символы,
			// Либо только разрешённые символы (например, только "-" или "123-")
			const regex = new RegExp(
				`^(?:[А-Яа-яЁё${allowedSymbols}]+|${allowedSymbols ? `[${allowedSymbols}]+` : ''})$`,
			);

			return regex.test(value);
		},
		checkOrderHashAndReset() {
			if (this.orderHash) {
				this.$emit('reset');
			}
			return this.orderHash;
		},
		productChangeHandler(data) {
			if (!this.block?.products.length) return;
			const product = this.block?.products.find((_product) => +_product.id === +data.products);
			this.setProduct(product);
			this.setPrice({ value: this.product?.price, key: 'initial' });
			this.setPrice({ value: this.product?.program_price_with_vat, key: 'withVat' });
		},
	},
};
